import RequestService from './request-service';

// Query the Pricing Engine for a price
export default class SwishBetRequest extends RequestService {
  constructor() {
    super();
    this.endpoint = this.$config.endpoints.swishBetRequest;
    this.postParams = {
      pa: false,
      bre: [],
    }
  }
}